module.exports = "/images/goback.svg";